













































































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import VehicleForm from './VehicleForm/VehicleForm.vue';
import uniq from 'lodash/uniq';
import DriverForm from './DriverForm/DriverForm.vue';
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'exportData'
    ])
  },
  components: {
    TitleBar
  }
})
export default class DeliveryVehiclesManager extends Vue {
  // radioButton = 1;
  // open = false

  opened: any[] = [];

  get titleStack () {
    return [
      'Доставка', 'Управлние машинами и водителями'
    ]
  }

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }


  private delayFilter: any = null
  private delayFilterValue: any = null

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
      query: {
        ...this.$route.query, [this.delayFilter]: this.delayFilterValue
      }
    })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
    this.delayFilterValue = value
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  // ---------------------------------------------------------------------------

  openVehicle(row: any) {
    this.$buefy.modal.open({
      component: VehicleForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openDriver(row: any, vehicle: any) {
    this.$buefy.modal.open({
      component: DriverForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: vehicle ? {
          vehicle_id: vehicle.id
        } : {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }


  driverArchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/driverToArchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Водитель помечен архивным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  driverUnarchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/driverToUnarchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Водитель помечен активным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  veichelArchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/veichelToArchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Автомобиль помечен архивным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  veichelUnarchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/veichelToUnarchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Автомобиль помечен активным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }


  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // this.checkFilterChange();
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
